module.exports = __webpack_public_path__ + "static/media/special_7.6cf1c5d3.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/special/special_7.csv
// module id = 743
// module chunks = 0